<mat-form-field appearance="outline" style="width: 100%;" >
  <mat-label>{{'EMAIL_TEMPLATE' | translate}}</mat-label>
  <mat-select [value]="emailTemplateId" (selectionChange)="onEmailTemplateChange($event)">
    <mat-option
      *ngFor="let emailTemplate of emailTemplateList"
      [value]="emailTemplate.id">{{emailTemplate.name}}
    </mat-option>
  </mat-select>
</mat-form-field>
